import React from "react";
import { SiteLayout } from "../components/site/SiteLayout";
import { useSeo } from "../lib/seo";

export default function PrivacyPolicyPage() {
  useSeo({
    title: "Privacy Policy",
    description: "How Wald Enterprise collects, uses and protects personal information, in line with POPIA.",
    path: "/privacy-policy",
  });
  return (
    <SiteLayout>
      <section className="border-b border-border">
        <div className="container-wald py-20 md:py-28">
          <div className="eyebrow mb-6">Legal</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            Privacy Policy
          </h1>
          <p className="mt-6 max-w-2xl opacity-70 text-sm">Last updated: 16 October 2026</p>
        </div>
      </section>
      <section>
        <div className="container-wald py-16 max-w-3xl space-y-10">
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Who we are</h2>
            <p className="opacity-85 leading-relaxed">
              Wald Enterprise ("Wald", "we", "us") is a South African agricultural software and AgriTech
              company. This policy explains what personal information we collect through wald.co.za, why
              we collect it, and how we handle it in line with the Protection of Personal Information Act
              (POPIA).
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Information we collect</h2>
            <ul className="list-disc pl-5 space-y-2 opacity-85 leading-relaxed">
              <li>Contact details you submit through our enquiry or discovery-call forms (name, email, phone, company, message).</li>
              <li>Basic usage analytics (pages visited, approximate location, device/browser type) via Google Analytics.</li>
              <li>A theme preference and cookie-consent choice stored in your browser's local storage.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">How we use it</h2>
            <p className="opacity-85 leading-relaxed">
              We use the information you submit to respond to enquiries, schedule discovery calls, and
              follow up on engagements. Analytics data helps us understand how the site is used so we can
              improve it. We do not sell personal information, and we do not use it for anything beyond
              these purposes.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Cookies &amp; analytics</h2>
            <p className="opacity-85 leading-relaxed">
              We use a minimal set of cookies: one to remember your light/dark theme preference, one to
              remember your cookie-consent choice, and Google Analytics cookies for aggregate usage
              statistics. You can decline non-essential cookies via the consent banner, and you can clear
              cookies at any time through your browser settings.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Data security</h2>
            <p className="opacity-85 leading-relaxed">
              We take reasonable technical and organisational measures to protect personal information
              against loss, misuse and unauthorised access, including encrypted transport (HTTPS) and
              access controls on our systems.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Your rights</h2>
            <p className="opacity-85 leading-relaxed">
              Under POPIA, you may request access to, correction of, or deletion of personal information
              we hold about you. To make a request, email{" "}
              <a href="mailto:info@wald.co.za" className="copper-link underline underline-offset-2">info@wald.co.za</a>.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Contact</h2>
            <p className="opacity-85 leading-relaxed">
              Questions about this policy can be directed to{" "}
              <a href="mailto:info@wald.co.za" className="copper-link underline underline-offset-2">info@wald.co.za</a>{" "}
              or Wald Enterprise, Pretoria, South Africa.
            </p>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
